import { each } from 'lodash';
import Vue from 'vue';
import Sport from './model/sport';
import Tournament from './model/tournament';
import TournamentBetTemplate from './model/tournamentBetTemplate';
import Bet from './model/bet';
import Match from './model/match';

function updateItemsSelection(items, isActive) {
  if (items) {
    items.forEach((item) => {
      item.updateActiveState(isActive);
      item.updatePropagateSelection(isActive);
    });
  }
}

// Filter bets by tournament bet templates
function filteredBets(bets, tournamentBetTemplates, betTemplateId) {
  const templateBetIds = [];
  tournamentBetTemplates.forEach((tbt) => {
    if (tbt.id !== betTemplateId) return;
    each(tbt.bets, bet => templateBetIds.push(bet.id));
  });
  return bets.filter(bet => templateBetIds.indexOf(bet.id) > -1);
}

export default {
  loadSports(state, sports) {
    state.selectedId = {
      sport: '',
      tournament: '',
      bet: '',
    };
    state.tournaments = {};
    state.tournamentBetTemplates = {};
    state.bets = {};
    state.matches = {};
    state.sports = [];
    sports.forEach(sport => state.sports.push(new Sport(sport)));
  },
  loadTournaments(state, data) {
    const tournaments = data.map(tournament => new Tournament(tournament));
    Vue.set(state.tournaments, state.selectedId.sport, tournaments);

    // Select all tournaments on initial propagation
    const sport = state.sports.find(s => s.id === state.selectedId.sport);
    if (sport.active && sport.propagateSelection) {
      updateItemsSelection(tournaments, true);
    } else if (!sport.active) {
      updateItemsSelection(tournaments, false);
    }
  },
  loadBets(state, data) {
    const bets = data.map(bet => new Bet(bet));
    Vue.set(state.bets, state.selectedId.tournament, bets);

    // Select all bets on initial propagation
    const tournament = state.tournaments[state.selectedId.sport]
      .find(t => t.id === state.selectedId.tournament);
    if (tournament.active && tournament.propagateSelection) {
      if (tournament.betTemplate.id) {
        this.dispatch('prematch/customSelection/updateBetTemplateSelection', tournament);
      } else {
        updateItemsSelection(bets, true);
      }
    } else if (!tournament.active) {
      updateItemsSelection(bets, false);
    }
  },
  loadMatches(state, data) {
    const matches = data.map(match => new Match(match));
    if (!state.matches[state.selectedId.tournament]) {
      Vue.set(state.matches, state.selectedId.tournament, {});
    }
    Vue.set(state.matches[state.selectedId.tournament], state.selectedId.bet, matches);

    // Select all matches on initial propagation
    const bet = state.bets[state.selectedId.tournament]
      .find(b => b.id === state.selectedId.bet);
    if (bet.active && bet.propagateSelection) {
      updateItemsSelection(matches, true);
    } else if (!bet.active) {
      updateItemsSelection(matches, false);
    }
  },
  loadTournamentBetTemplates(state, data) {
    const betTemplates = data.map(tbTemplate => new TournamentBetTemplate(tbTemplate));
    Vue.set(state.tournamentBetTemplates, state.selectedId.sport, betTemplates);
  },
  updateSelectionToRight(state, { type, item }) {
    item.updatePropagateSelection(item.active);
    switch (type) {
      case 'sport': {
        const tournaments = state.tournaments[item.id];
        if (!tournaments) return;

        updateItemsSelection(tournaments, item.active);
        tournaments.forEach((tournament) => {
          const bets = state.bets[tournament.id];
          if (!bets) return;

          if (tournament.betTemplate.id) {
            this.dispatch('prematch/customSelection/updateBetTemplateSelection', tournament);
          } else {
            updateItemsSelection(bets, tournament.active);
          }

          bets.forEach((bet) => {
            const matches = state.matches[tournament.id]
              ? state.matches[tournament.id][bet.id] : [];
            updateItemsSelection(matches, bet.active);
          });
        });
        break;
      }
      case 'tournament': {
        const bets = state.bets[item.id];
        if (!bets) return;

        if (item.betTemplate.id) {
          this.dispatch('prematch/customSelection/updateBetTemplateSelection', item);
        } else {
          updateItemsSelection(bets, item.active);
        }

        bets.forEach((bet) => {
          const matches = state.matches[item.id]
            ? state.matches[item.id][bet.id] : [];
          updateItemsSelection(matches, bet.active);
        });
        break;
      }
      case 'bet': {
        each(state.matches, (mTournament) => {
          const matches = mTournament[item.id];
          updateItemsSelection(matches, item.active);
        });
        break;
      }
      default:
    }
  },
  updateBetTemplateSelection(state, item) {
    if (item.betTemplate.id) {
      const tbt = state.tournamentBetTemplates[state.selectedId.sport];
      const bets = state.bets[item.id];
      updateItemsSelection(bets, false);
      updateItemsSelection(filteredBets(bets, tbt, item.betTemplate.id), item.active);
    }
  },
  updateSelectionOptions(state, data) {
    Object.keys(data).forEach((key) => {
      state.isSelected[key] = data[key];
    });
  },
  setSelectedId(state, data) {
    Object.keys(data).forEach((key) => {
      state.selectedId[key] = data[key];
    });
  },
  setCopiedBets(state, data) {
    state.copiedBets = data;
  },
  pasteCopiedBets(state, data) {
    data.forEach((bet) => {
      const found = state.copiedBets.find(copiedBet => copiedBet.id === bet.id);
      if (found) bet.updateActiveState(found.active);
    });
  },
};
